import React from 'react';
import ModalCitaMedica from './ModalCitaMedica';
import { HashLink as Link } from 'react-router-hash-link';
import { useSelector, useDispatch, shallowEqual } from 'react-redux';
import NavDropdown from 'react-bootstrap/NavDropdown';
import {
  logout,
  setUrlBack,
  closeSidebar,
  toggleMenuEducacion,
  toggleMenuEntrenamiento,
  toggleMenuHerramientas,
  toggleMenuDiario,
  toggleMenuQs,
  toggleMenuAsmaE,
  toggleNavigation
} from '../store/actions';
import Perfil from './Perfil';
import { URL } from '../store/constants';



// import { Link } from "react-router-dom";

export default function MenuPrincipal(props) {
  const [modalShow, setModalShow] = React.useState(false);
  const [modalCitaMedica, setModalCitaMedica] = React.useState(false);
  const [modalPerfil, setModalPerfil] = React.useState(false);
  const [ingresar, setIngresar] = React.useState(false);
  const userState = useSelector((state) => state.user.authState);
  const user = useSelector((state) => state.user.authData);
  const subMenuEducacionClass = useSelector((state) => state.menu.subMenuEducacion, shallowEqual)
  const subMenuEntrenamientoClass = useSelector((state) => state.menu.subMenuEntrenamiento, shallowEqual)
  const subMenuHerramientasClass = useSelector((state) => state.menu.subMenuHerramientas, shallowEqual)
  const subMenuQuienesSomosClass = useSelector((state) => state.menu.subMenuQuienesSomos, shallowEqual)
  const subMenuDiarioClass = useSelector((state) => state.menu.subMenuDiario, shallowEqual)
  const subMenuAsmaEClass = useSelector((state)=>state.menu.subMenuAsmaE, shallowEqual)
  const country = useSelector((state)=> state.country, shallowEqual)




  const dispatch = useDispatch();
  const handleSelect = (eventKey) => {
    if (eventKey == '1') {
      dispatch(logout());
    } else {
      setModalPerfil(true);
    }
  };
  let profesionalesTrue = true;
  let profesionalesFalse = false;

  const handleCloseSidebar = () => {
    dispatch(closeSidebar())
  }

  const handleToggleMenuEducacion = () => {
    dispatch(toggleMenuEducacion(subMenuEducacionClass))
  }

  const handleToggleMenuEntrenamiento = () => {
    dispatch(toggleMenuEntrenamiento(subMenuEntrenamientoClass))
  }

  const handleToggleMenuHerramientas = () => {
    dispatch(toggleMenuHerramientas(subMenuHerramientasClass))
  }

  const handleToggleMenuDiario = () => {
    dispatch(toggleMenuDiario(subMenuDiarioClass))
  }

  const handleToggleMenuQuienesSomos = () => {
    dispatch(toggleMenuQs(subMenuQuienesSomosClass))
  }
  const handleToggleMenuAsmaE = () => {
    dispatch(toggleMenuAsmaE(subMenuAsmaEClass))
  }

  const buttonTogglerClass = useSelector((state) => state.menu.buttonTogglerClass, shallowEqual)
  const homeClass = useSelector((state) => state.menu.homeClass, shallowEqual)
  const internaClass = useSelector((state) => state.menu.internaClass, shallowEqual)

  const handleToggleMenu = () => {
    dispatch(toggleNavigation(homeClass, internaClass))
  }

  return (
    <nav className="menu-principal" id="navigation">
      {props.sections.length && (
        <div className="menu-principal-container">
          <div className="menu-ss2020-container">
            <ul id="menu-ss2020" className="menu-slider-right">
            {
                  <li className="menu-item">
                    <a
                      title="Dale voz a tus pulmones"
                      href="/dalevozatuspulmones"
                      className="nav-link"
                      aria-current="page">
                      Dale voz a tus pulmones 
                    </a>
                  </li> 
              }
               {/*{userState ? (
                <li className="menu-item ingresar-mobile" id="educacion">
                  <a
                    id="texto-verde"
                    className="enfermeria texto-azul"
                    href="#"
                    style={{ color: '#19bfb9' }}>
                    <NavDropdown
                      onSelect={handleSelect}
                      title={user.given_name}
                      id="nav-dropdown"
                      className="nav-link">
                      <NavDropdown.Item eventKey="2">Perfil</NavDropdown.Item>
                      <NavDropdown.Item eventKey="1">Salir</NavDropdown.Item>
                    </NavDropdown>
                  </a>

                  <img
                    className="ingresar-icono-mobile"
                    src="/img/icono-ingresar-blanco.png"
                    alt=""
                  />
                </li>
              ) : (
                  <li className="menu-item ingresar-mobile" id="educacion">
                    <a
                      onClick={() => {
                        setIngresar(true);
                        setModalCitaMedica(true);
                      }}
                      title="Educación"
                      href="#"
                      className="nav-link"
                      aria-current="page"
                      id="texto-verde">
                      Ingresar
                  </a>
                    <img
                      className="ingresar-icono-mobile"
                      src="/img/icono-ingresar-verde.png"
                      alt=""
                    />
                  </li>
                )} */}
               <li className="menu-item" id="educacion">
                <a
                  onClick={handleToggleMenuEducacion}
                  title="Educación"
                  href="#"
                  className="nav-link"
                  aria-current="page">
                  Educación
                </a>
              </li>
              <li className="menu-item">
                <a
                  onClick={handleToggleMenuHerramientas}
                  title="Herramientas"
                  href="#"
                  className="nav-link"
                  aria-current="page">
                  Herramientas
                </a>
              </li>
              {/* <li className="menu-item">
                <Link to={"/contacto"}>
                  <a
                      className={"nav-link"}
                      title={"Contacto"}
                      aria-current={"page"}
                      onClick={handleToggleMenu}
                  >Contacto</a>
                </Link>
              </li> */}
              {/* {userState ? (
                <li className="menu-item">
                  <a
                    onClick={() => setModalShow(true)}
                    title="Entrenamiento Médico"
                    href="#"
                    className="nav-link active"
                    aria-current="page">
                    Información Médica
                  </a>
                </li>
              ) : (
                  <li
                    onClick={() => {
                      setIngresar(false);
                      setModalCitaMedica(true);
                      dispatch(setUrlBack(`${URL}entrenamiento-medico`));
                    }}
                    className="menu-item">
                    <a
                      title="Entrenamiento Médico"
                      href="#"
                      className="nav-link"
                      aria-current="page">
                      Información Médica
                    </a>
                  </li>
                )} */
                country.selectedCountry === "CO" ? 
                <li className="menu-item">
                  <a
                    title="Dale voz a tus pulmones"
                    href="https://www.azmedical.co/"
                    className="nav-link"
                    aria-current="page">
                    Información Médica
                  </a>
                </li> : null
                }
                {
                country.selectedCountry === "PE" ?
                  <li className="menu-item">
                    <a
                      title="Dale voz a tus pulmones"
                      href="https://www.azmedical.pe/"
                      className="nav-link"
                      aria-current="page">
                      Información Médica
                    </a>
                  </li> : null
                }
                {
                  country.selectedCountry === "EC" ?
                  <li className="menu-item">
                    <a
                      title="Dale voz a tus pulmones"
                      href="https://www.azmedical.ec/"
                      className="nav-link"
                      aria-current="page">
                      Información Médica
                    </a>
                  </li> : null
                }
              {/* <li className="menu-item">
                <a
                  onClick={handleToggleMenuDiario}
                  title="Diario Asma Zero"
                  href="#"
                  className="nav-link"
                  aria-current="page">
                  Diario Asma Zero
                </a>
              </li> */}
              {
                /*country.selectedCountry === "CO" ?

                  <li className="menu-item">
                    <a
                      onClick={handleToggleMenuAsmaE}
                      title="Conocer más sobre asma-e"
                      href="#"
                      className="nav-link"
                      aria-current="page">
                      Conocer más sobre asma-e 
                    </a>
                  </li> 

                :null*/
              }

              {/* {
                country.selectedCountry === "CO" ? 
              
                  <li className="menu-item">
                    <Link
                      onClick={handleCloseSidebar}
                      title="Eventos"
                      to="/eventos"
                      className="nav-link"
                      aria-current="page">
                      Eventos
                    </Link>
                  </li>
                  
                :null
              }
              <li className="menu-item">
                <a
                  onClick={handleToggleMenuQuienesSomos}
                  title="Quiénes Somos"
                  href="#"
                  className="nav-link"
                  aria-current="page">
                  Quiénes Somos
                </a>
              </li> */}
{/*               <li className="menu-item">
                <Link
                  onClick={handleCloseSidebar}
                  title="Contacto"
                  to="/contacto"
                  className="nav-link"
                  aria-current="page">
                  Contacto
                </Link>
              </li>
              <li className="menu-item enfermeria-mobile">
                <a
                  onClick={handleCloseSidebar}
                  title=""
                  href="https://api.whatsapp.com/send?phone=5491138703406&text=Hola%20Asma%20Zero"
                  className="nav-link"
                  target="_blank"
                  aria-current="page">
                  Enfermería Online
                </a>
                <a
                  href="https://api.whatsapp.com/send?phone=5491138703406&text=Hola%20Asma%20Zero"
                  onClick={handleCloseSidebar}>
                  <img
                    className="enfermeria-icono-mobile"
                    src="/img/icono-wsp-bordo.png"
                    alt=""
                  />
                </a>
              </li> */}
            </ul>
          </div>
          <div className="menu-redes-mobile">
            <a href="https://www.facebook.com/AsmaZero-Andino-104277218426999" target="_blank">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="25.056"
                height="25.056"
                viewBox="0 0 23.056 23.056">
                <path
                  id="Icon_awesome-facebook-square"
                  data-name="Icon awesome-facebook-square"
                  d="M20.586,2.25H2.47A2.47,2.47,0,0,0,0,4.72V22.836a2.47,2.47,0,0,0,2.47,2.47H9.534V17.468H6.292v-3.69H9.534V10.966c0-3.2,1.9-4.965,4.821-4.965a19.643,19.643,0,0,1,2.857.249V9.389H15.6a1.845,1.845,0,0,0-2.08,1.993v2.4h3.54l-.566,3.69H13.522v7.839h7.064a2.47,2.47,0,0,0,2.47-2.47V4.72A2.47,2.47,0,0,0,20.586,2.25Z"
                  transform="translate(0 -2.25)"
                  fill="#fff"
                />
              </svg>
            </a>

            <a href="https://www.instagram.com/asmazeroandino/" target="_blank">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="25.929"
                height="25.929"
                viewBox="0 0 21.929 21.929">
                <path
                  id="Trazado_1169"
                  data-name="Trazado 1169"
                  d="M2.525-6.4A3.441,3.441,0,0,0,3.571-8.929a3.441,3.441,0,0,0-1.046-2.525A3.441,3.441,0,0,0,0-12.5a3.441,3.441,0,0,0-2.525,1.046A3.441,3.441,0,0,0-3.571-8.929,3.441,3.441,0,0,0-2.525-6.4,3.441,3.441,0,0,0,0-5.357,3.441,3.441,0,0,0,2.525-6.4Zm1.367-6.417A5.3,5.3,0,0,1,5.5-8.929a5.3,5.3,0,0,1-1.6,3.892A5.3,5.3,0,0,1,0-3.432a5.3,5.3,0,0,1-3.892-1.6A5.3,5.3,0,0,1-5.5-8.929a5.3,5.3,0,0,1,1.6-3.892A5.3,5.3,0,0,1,0-14.425,5.3,5.3,0,0,1,3.892-12.821Zm2.734-2.734A1.236,1.236,0,0,1,7-14.648a1.236,1.236,0,0,1-.377.907,1.236,1.236,0,0,1-.907.377,1.236,1.236,0,0,1-.907-.377,1.236,1.236,0,0,1-.377-.907,1.236,1.236,0,0,1,.377-.907,1.236,1.236,0,0,1,.907-.377A1.236,1.236,0,0,1,6.627-15.555ZM1.067-17.725,0-17.718l-1.067-.007q-.97-.007-1.472,0t-1.346.042a11.056,11.056,0,0,0-1.437.14,5.594,5.594,0,0,0-1,.258,3.619,3.619,0,0,0-1.228.809,3.619,3.619,0,0,0-.809,1.228,5.594,5.594,0,0,0-.258,1,11.056,11.056,0,0,0-.14,1.437q-.035.844-.042,1.346T-8.8-10q.007.97.007,1.067T-8.8-7.861q-.007.97,0,1.472t.042,1.346a11.056,11.056,0,0,0,.14,1.437,5.594,5.594,0,0,0,.258,1,3.619,3.619,0,0,0,.809,1.228A3.619,3.619,0,0,0-6.32-.572a5.594,5.594,0,0,0,1,.258,11.056,11.056,0,0,0,1.437.14q.844.035,1.346.042t1.472,0L0-.14l1.067.007q.97.007,1.472,0T3.885-.174a11.056,11.056,0,0,0,1.437-.14,5.594,5.594,0,0,0,1-.258,3.619,3.619,0,0,0,1.228-.809,3.619,3.619,0,0,0,.809-1.228,5.594,5.594,0,0,0,.258-1,11.055,11.055,0,0,0,.14-1.437q.035-.844.042-1.346t0-1.472q-.007-.97-.007-1.067T8.8-10q.007-.97,0-1.472t-.042-1.346a11.056,11.056,0,0,0-.14-1.437,5.594,5.594,0,0,0-.258-1,3.62,3.62,0,0,0-.809-1.228,3.619,3.619,0,0,0-1.228-.809,5.594,5.594,0,0,0-1-.258,11.056,11.056,0,0,0-1.437-.14q-.844-.035-1.346-.042T1.067-17.725Zm9.577,4.374q.07,1.228.07,4.422t-.07,4.422A6.545,6.545,0,0,1,8.915-.014a6.545,6.545,0,0,1-4.492,1.73q-1.228.07-4.422.07t-4.422-.07A6.544,6.544,0,0,1-8.915-.014a6.544,6.544,0,0,1-1.73-4.492q-.07-1.228-.07-4.422t.07-4.422a6.545,6.545,0,0,1,1.73-4.492,6.544,6.544,0,0,1,4.492-1.73q1.228-.07,4.422-.07t4.422.07a6.545,6.545,0,0,1,4.492,1.73A6.545,6.545,0,0,1,10.645-13.351Z"
                  transform="translate(10.964 19.893)"
                  fill="#fff"
                  stroke="#fff"
                  strokeWidth="0.5"
                />
              </svg>
            </a>

            {/* <a href="http://www.youtube.com/c/asmazeroaz" target="_blank">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="30.594"
                height="25"
                viewBox="0 0 25.594 18">
                <path
                  id="Trazado_1168"
                  data-name="Trazado 1168"
                  d="M12.281-15.187a21.182,21.182,0,0,1,.469,3.844L12.8-9,12.75-6.656a21.431,21.431,0,0,1-.469,3.891,3.269,3.269,0,0,1-.844,1.406,3.249,3.249,0,0,1-1.453.844,33.341,33.341,0,0,1-5.719.469L0,0-4.266-.047A33.341,33.341,0,0,1-9.984-.516a3.249,3.249,0,0,1-1.453-.844,3.269,3.269,0,0,1-.844-1.406,21.431,21.431,0,0,1-.469-3.891L-12.8-9q0-1.031.047-2.344a21.182,21.182,0,0,1,.469-3.844,3.249,3.249,0,0,1,.844-1.453,3.249,3.249,0,0,1,1.453-.844,33.341,33.341,0,0,1,5.719-.469L0-18l4.266.047a33.341,33.341,0,0,1,5.719.469,3.249,3.249,0,0,1,1.453.844A3.249,3.249,0,0,1,12.281-15.187ZM-2.625-5.156,4.078-9l-6.7-3.8Z"
                  transform="translate(12.797 18)"
                  fill="#fff"
                />
              </svg>
            </a> */}
          </div>
        </div>
      )}
      
      <ModalCitaMedica
        ingresar={true}
        show={modalShow}
        onHide={() => setModalShow(false)}
      />

      <Perfil show={modalPerfil} onHide={() => setModalPerfil(false)} />
    </nav>
  );
}
